import QcPageLayout from '../components/QcPageLayout';
import QcPlaceholderCard from '../components/QcPlaceholderCard';

export default function AssignedTaskPage() {
  return (
    <QcPageLayout
      title="Assigned Task"
      metaDescription="Global view of assigned QC tasks."
      breadcrumbTitle="Assigned Task"
    >
      <QcPlaceholderCard
        heading="Assigned Task"
        body="Tasks that have been assigned across the team will be listed here."
      />
    </QcPageLayout>
  );
}
